export enum Permission {
  AccessGroupRead = 'access-group.read',
  AccessGroupRestrictionsRead = 'access-group-restrictions.read',
  AccessGroupRestrictionsWrite = 'access-group-restrictions.write',
  AccessGroupWrite = 'access-group.write',
  ChargingStationLocationDefaultsWrite = 'charging-station-location-defaults.write',
  ChargingStationLocationPricePolicyWrite = 'charging-station-location-price-policy.write',
  ChargingStationLocationRead = 'charging-station-location.read',
  ChargingStationLocationWrite = 'charging-station-location.write',
  ChargingUserAccessGroupWrite = 'charging-user-access-group.write',
  ChargingUserAppInvitationCreate = 'charging-user-app-invitation.create',
  ChargingUserCreate = 'charging-user.create',
  ChargingUserIdTagWrite = 'charging-user-id-tag.write',
  ChargingUserRead = 'charging-user.read',
  ChargingUserWrite = 'charging-user.write',
  ChargingUserOrganizationSwitch = 'charging-user-organization.switch',
  ConnectorPictureWrite = 'connector-picture.write',
  CustomerReportDownload = 'customer-report.download',
  DepartmentGroupRead = 'department-group.write',
  DepartmentRead = 'department.read',
  DepartmentWrite = 'department.write',
  IdTagRead = 'id-tag.read',
  IdTagToggleAccess = 'id-tag.toggle-access',
  IdTagWrite = 'id-tag.write',
  IdTagEdit = 'id-tag.edit',
  ConvertToFleetIdTag = 'id-tag.convert-to-fleet-id-tag',
  ImitationStartOrStop = 'imitation.start-or-stop',
  IncidentRead = 'incident.read',
  ModuleRead = 'module.read',
  ModuleWrite = 'module.write',
  OkAppEmulator = 'ok-app-emulator.read',
  OrganizationDelete = 'organization.delete',
  OrganizationDiscountTypeWrite = 'organization-discount-type.write',
  OrganizationRead = 'organization.read',
  OrganizationWrite = 'organization.write',
  PayterPaymentTerminalRead = 'payter-payment-terminal.read',
  PayterPaymentTerminalWrite = 'payter-payment-terminal.write',
  PricePolicyRead = 'price-policy.read',
  PricePolicyWrite = 'price-policy.write',
  PriceRegulationRead = 'price-regulation.read',
  PriceRegulationWrite = 'price-regulation.write',
  PriceSignWrite = 'price-sign.write',
  PriceSignRead = 'price-sign.read',
  QuickSearchRead = 'quick-search.read',
  UserRead = 'user.read',
  KickbackWrite = 'kickback.write',
}
